import { MessageTypeEnum, SnackbarService } from '@fleet-beat/core';
import { Observable, of } from 'rxjs';
import { catchError, filter } from 'rxjs/operators';

export class ApiError extends Error {
  type: 'api';
  messages: string[];
  code?: string;

  constructor(messages: string[], code?: string) {
    const message: string = messages.reduce((prev: string, curr: string) => `${prev} ${curr}`, '');
    super(message);

    this.type = 'api';
    this.messages = messages;
    this.code = code;
  }
}

export function catchApiError(
  snackbarService: SnackbarService,
  isThrowError: boolean = false,
  emitObservable: boolean = false,
): <T>(source: Observable<T>) => Observable<T> {
  return <T>(source: Observable<T>): Observable<T> =>
    source.pipe(
      catchError((error: ApiError & Error) => {
        let messages: string[] = undefined;
        if (error.type === 'api') {
          messages = error.messages;
        } else if (error.name === 'HttpErrorResponse') {
          messages = ['Unknown server error. Please try later.'];
        }

        if (messages) {
          snackbarService.show({ message: messages, type: MessageTypeEnum.ERROR });

          if (isThrowError) {
            throw error;
          } else {
            return of(undefined as T).pipe(filter(() => emitObservable));
          }
        } else {
          throw error;
        }
      }),
    );
}
